import { useMemo } from 'react';
import { SingleTrimSpec } from '../../../../../services/vehicle-data-service/vehicle-data-service.types';
import { SearchContentProps } from '../../../search-bar/hooks/use-search-content';
import SearchBarInput from '../../../search-bar/search-bar-input/search-bar-input';
import { DyfVehicleSpecs } from '../../dyf-vehicle-specs/dyf-vehicle-specs';

export const SearchOrSpecWrap = ({
    flow,
    searchContent,
    selectedSpecs,
    selectedTrim,
    eligibleFeatureGuide,
    shouldShowTrimSelector,
}: {
    flow: 'vin' | 'ymm';
    selectedSpecs: SingleTrimSpec[];
    selectedTrim: string | null;
    eligibleFeatureGuide: boolean;
    searchContent: SearchContentProps | null;
    shouldShowTrimSelector: boolean;
}) => {
    const shouldShowSearchBar = useMemo(() => {
        return eligibleFeatureGuide && searchContent && flow == 'vin';
    }, [eligibleFeatureGuide, searchContent, flow]);

    return (
        <div className="search-or-spec--wrap">
            {shouldShowSearchBar && (
                <div
                    className="billboard-vehicle-search--wrap"
                    data-testid={'billboard-search-input'}
                >
                    <SearchBarInput
                        hideSearchBarTitle={true}
                        searchContent={searchContent!}
                    />
                </div>
            )}

            {shouldShowTrimSelector && (
                <div className="billboard-vehicle-spec--wrap">
                    {!!selectedTrim && (
                        <DyfVehicleSpecs specs={selectedSpecs} />
                    )}
                </div>
            )}
        </div>
    );
};
